import { WithTooltip } from '../../../core/WithTooltip';
import { TextSource } from '../../../../types/text';
import formatForAnaltyics from '../../../../utils/formatForAnalytics';

import { HistoryButtonProps } from './types';
import useStyles from './styles';
import { cloneFontData } from './helpers';

export function HistoryButton({
  Icon,
  enabled,
  getData,
  setData,
  tooltipText,
  analytics,
}: HistoryButtonProps) {
  const classes = useStyles();
  let onClick: () => void;
  let className = classes.historyDisabled;

  if (enabled) {
    className = classes.historyIcon;
    onClick = () => {
      const newItem = cloneFontData(getData());

      newItem[2] = TextSource.HISTORY;

      setData(newItem);
      analytics.pageClick({
        page_path: window.location.pathname,
        action_type: formatForAnaltyics(tooltipText),
      });
    };
    return (
      <WithTooltip text={tooltipText} position="up">
        <Icon className={className} onClick={onClick} />
      </WithTooltip>
    );
  }

  return <Icon className={className} onClick={onClick} />;
}
